/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import getCnpdfLoggingManager from "logging/CnpdfLoggingManager";
import * as stores from "stores";

export const logCNPDFComponentFetchLogs = (response = {}) => {
  const { cnpdfComponentsFetched } = response;
  if (cnpdfComponentsFetched) {
    const cnpdfLoggingManager = getCnpdfLoggingManager();
    cnpdfLoggingManager.cacheComponentFetchLogs(cnpdfComponentsFetched);
    delete response.cnpdfComponentsFetched;
  }
};

export const logCNPDFUpdateObjectCount = manifest => {
  let updateComponentCount = 0;
  if (manifest?.children) {
    manifest.children.forEach(child => {
      if (child.path === "updates") {
        updateComponentCount = child.children.length;
      }
    });
  }
  stores.documentStore.setUpdateObjectCount(updateComponentCount);
};
